import { forwardRef, useContext } from "react";
import type { ComponentProps } from "react";
import { chakra } from "@chakra-ui/react";
import { IconContext } from "../IconContext";
const FullscreenOutlinedIcon = forwardRef<SVGSVGElement, Omit<ComponentProps<typeof chakra["svg"]>, "minWidth" | "width" | "maxWidth" | "minHeight" | "height" | "maxHeight" | "__css"> & {
  size?: "xs" | "sm" | "md" | "lg";
}>(({
  size: sizeProp,
  ...rest
}, ref) => {
  const iconContext = useContext(IconContext);
  const size = sizeProp || iconContext.size;
  const width = {
    xs: "0.875rem",
    sm: 4,
    md: 5,
    lg: 6
  }[size];
  const props = {
    ...rest,
    minWidth: width,
    width,
    maxWidth: width,
    minHeight: width,
    height: width,
    maxHeight: width,
    fill: rest.fill || "currentColor"
  } as ComponentProps<typeof chakra["svg"]>;
  return <chakra.svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 -960 1080 1080" __css={{
    "& > *": {
      "transform": "translate(60px,60px)"
    }
  }} ref={ref} {...props}><path d="M95-95v-238h94v144h144v94H95Zm533 0v-94h143v-144h95v238H628ZM95-628v-238h238v95H189v143H95Zm676 0v-143H628v-95h238v238h-95Z" /></chakra.svg>;
});
export default FullscreenOutlinedIcon;